import { Grid, Link, Box } from '@mui/material';
import { HeaderShort, JFormik } from '../components';
import { routeNames } from '../config';
import * as Yup from 'yup';

export interface ForgotPasswordProps {
  reset?: Function;
  navigate?: Function;
}

export const ForgotPassword = ({ reset, navigate }: ForgotPasswordProps) => {
  return (
    <Box sx={{ bgcolor: 'rgba(249,255,243,1)', paddingX: { xs: 2, sm: 3 } }}>
      <HeaderShort position="fixed" />
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100vh',
          minHeight: 640,
        }}
      >
        <Grid item xs={12} sm={8} md={6} lg={5} xl={4}>
          <JFormik
            initialValues={(resource: any) => ({ email: '' })}
            validationSchema={Yup.object({
              email: Yup.string()
                .required('Email is required')
                .email('Invalid email address'),
            })}
            handleSubmit={(values: any) =>
              reset ? reset(values) : console.info(values)
            }
            form={[
              {
                name: 'h4',
                itemType: 'typography',
                label: 'Forgot Your Password?',
                jItemProps: {
                  variant: 'h4',
                  sx: { textAlign: 'center', fontSize: { xs: 28, sm: 34 } },
                },
              },
              {
                name: 'subtitle1',
                itemType: 'typography',
                label:
                  'Please enter your email address to request a password reset.',
                jItemProps: {
                  variant: 'subtitle1',
                  color: 'textSecondary',
                  sx: {
                    textAlign: 'center',
                    marginTop: -1,
                    marginBottom: 3,
                    lineHeight: 1.5,
                  },
                },
              },
              {
                name: 'email',
                itemType: 'textfield',
                label: 'Email',
              },
              {
                name: 'submit',
                itemType: 'button',
                jItemProps: { type: 'submit' },
                label: 'Send Email',
              },
            ]}
          />
          <Link
            component="button"
            variant="body1"
            sx={{ mt: 5 }}
            onClick={() => {
              navigate
                ? navigate(routeNames.LOGIN)
                : console.info('back_to_signin');
            }}
          >
            Back to Sign in
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};
